import { render, staticRenderFns } from "./LapSection.vue?vue&type=template&id=9c99055e&scoped=true"
import script from "./LapSection.vue?vue&type=script&lang=js"
export * from "./LapSection.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style.css?vue&type=style&index=0&id=9c99055e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c99055e",
  null
  
)

export default component.exports